import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import PanelFilter from "../../shares/PanelFilter";
import RingCard from "./RingCard";
import MuiPagination from "../../shares/MuiPagination";
import useFetch from "../../../context/useFetch";
import { ageList, colorList, fixNumbers } from "../../../utils";
import ShowRingSizes from "./ShowRingSizes";
import AddRingTabThree from "./AddRingTabThree";
import PanelTable from "../../shares/PanelTable";
import { useUserData } from "../../../context/UserDataContext";

// import Others files

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "brand_name", name: "برند" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "seeـweights", name: "مشاهده وزن‌ها" },
  { colName: "add_ring", name: "افزودن" },
];

const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
];
const dataKey = ["code", "brand_name", "show_name", "gender", "color"];

const TabOne = (props) => {
  const { userData } = useUserData();

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [codeFilter, setCodeFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [kindFilter, setKindFilter] = useState(null);
  const [colorFilter, setColorFilter] = useState(null);
  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "اسم",
      label_en: "name",
      state: nameFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
    {
      type: "select",
      label_fa: "نوع",
      label_en: "kind",
      state: kindFilter,
      menuItems: ageList,
    },
    {
      type: "select",
      label_fa: "رنگ",
      label_en: "color",
      state: colorFilter,
      menuItems: colorList,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const [ringsList, setRingsList] = useState({ results: [] });
  const GetRingsApi = useFetch({
    method: "get",
    url: "Bangle_Service",
    pagination: paginationPageInfo,
    params: {
      name: nameFilter,
      code: fixNumbers(codeFilter),
      brand: brandFilter,
      color: colorFilter,
      gender: kindFilter,
    },

    trigger: true,
    setter: setRingsList,
    argFunc: (res) => {
      // setPageData(res);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);
    if (state == "color") setColorFilter(e.length > 0 ? e : null);
    if (state == "kind") setKindFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    GetRingsApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setNameFilter(null);
    setBrandFilter("all");
    setKindFilter("all");
    setColorFilter("all");

    GetRingsApi.reFetch();
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    // setRingsList({ results: [] });

    GetRingsApi.reFetch();
  };

  const buttonsList = [
    {
      label: "مشاهده وزن‌ها",
      component: (it) => <ShowRingSizes selectedRow={it} />,
    },
  ];
  const actionsList = [
    {
      label: "افزودن",
      component: (it) => <AddRingTabThree selectedRow={it} selectedUser={props.selectedUser}/>,
    },
  ];

  return (
    <>
      {props.selectedUser !== undefined ? (
        <div className="mb-4">
          <span className="text-myblue-100">
            مشتری انتخاب شده:{" "}
            <span className="text-gray-700">{props.selectedUser?.name}</span>
          </span>
        </div>
      ) : (
        ""
      )}
      <PanelFilter
        header="فیلتر النگوها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      {userData.job == "Admin" ? (
        <PanelTable
          header="محصولات:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={ringsList.results}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AccountBalanceIcon />}
        />
      ) : (
        <div className="grid md:grid-cols-4 md:gap-x-6 gap-y-4 md:gap-y-6">
          {ringsList.results.map((item, index) => {
            return [
              <>
                <RingCard
                  item={item}
                  type={item.gender == "woman" ? "زنانه" : "بچه گانه"}
                />
              </>,
            ];
          })}
        </div>
      )}

      <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      />
    </>
  );
};

export default TabOne;
